/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Lower_ThirdInputs */



/**
* | output |
* | --- |
* | "Lower Third (Recommended)" |
*
* @param {Ocr_Crop_Lower_ThirdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_lower_third = /** @type {((inputs?: Ocr_Crop_Lower_ThirdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Lower_ThirdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tiers inférieur (recommandé)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untere Drittel-Einblendung (Empfohlen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso (consigliato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижняя треть (рекомендуется)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tercio inferior (recomendado)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下方三分之一（推荐）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下部3分の1（推奨）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निचला तीसरा भाग (अनुशंसित)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Terço inferior (recomendado)")
	return /** @type {LocalizedString} */ ("Lower Third (Recommended)")
});